import React from 'react';
import { Video } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import packageJson from '../../package.json';

export const About = () => {
    const { t } = useTranslation();
    return (
        <div className="max-w-4xl mx-auto space-y-8 animate-fade-in pb-12">
            <div className="text-center space-y-4 mb-12">
                <div className="flex justify-center mb-6">
                    <img
                        src="/logo.jpg"
                        alt={t('about.logoAlt')}
                        className="h-32 w-32 rounded-full object-cover drop-shadow-xl hover:scale-105 transition-transform duration-500 ring-4 ring-primary/20"
                    />
                </div>
                <h1 className="text-4xl font-extrabold tracking-tight bg-gradient-to-r from-primary to-blue-500 bg-clip-text text-transparent">
                    Olga
                </h1>
                <p className="text-xl text-muted-foreground font-light max-w-2xl mx-auto">
                    {t('about.tagline')}
                </p>
                <div className="flex justify-center space-x-2">
                    <span className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-semibold uppercase tracking-wider">
                        v{packageJson.version} {t('about.betaSuffix')}
                    </span>
                    <span className="px-3 py-1 bg-green-500/10 text-green-500 rounded-full text-xs font-semibold uppercase tracking-wider">
                        {t('about.openSource')}
                    </span>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-6">
                <div className="bg-card border border-border rounded-xl p-8 hover:shadow-lg transition-all duration-300">
                    <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                        <Video className="w-6 h-6 text-primary" />
                    </div>
                    <h2 className="text-2xl font-bold mb-4">{t('about.whyTitle')}</h2>
                    <p className="text-muted-foreground leading-relaxed mb-4">
                        Olga bridges the gap between powerful features and beautiful design. It's built with a modern stack (React, Python FastAPI, OpenCV) to be lightweight, fast, and a joy to use every day.
                    </p>
                </div>
            </div>

            <div className="bg-card border border-border rounded-xl p-6">
                <h3 className="text-lg font-semibold mb-4 border-b border-border pb-2">{t('about.creditsTitle')}</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm text-muted-foreground">
                    <div className="flex flex-col space-y-1">
                        <span className="font-medium text-foreground">{t('about.sectionBackend')}</span>
                        <span>Python FastAPI</span>
                        <span>SQLAlchemy</span>
                        <span>PostgreSQL</span>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <span className="font-medium text-foreground">{t('about.sectionFrontend')}</span>
                        <span>React + Vite</span>
                        <span>TailwindCSS</span>
                        <span>Lucide Icons</span>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <span className="font-medium text-foreground">{t('about.sectionEngine')}</span>
                        <span>OpenCV</span>
                        <span>FFmpeg</span>
                        <span>Docker</span>
                    </div>
                </div>
            </div>

            <div className="text-center text-xs text-muted-foreground mt-8 px-4">
                <p className="font-mono uppercase opacity-70">
                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </p>
            </div>
        </div>
    );
};
